<template>
  <div>
    <div class="img-top">
      <!--      <div class="text-title">平台简介</div>-->
      <!--			<div class="text-subtitle">解决你的临时用电需求 专注用电需求</div>-->
    </div>
    <div style="height: 100%;background-color: #fff;padding-left: 15px;">
      <div class="section-tabs">
        <div style="display: flex;align-items: center;">
          <div style="font-size: 0.14rem;color: #8F8F8F;">厂商</div>
          <div style="margin: 10px 0;display: flex;margin-left: 75px;">

            <input type="text" v-model="query.name">
            <button style="margin-left: 20px;" @click="serach">搜索</button>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 80%; margin-left: 10%;background-color: #fff;padding: 30px;margin-top: 15px;">
      <!-- 循环渲染每一个新闻项目 -->
      <company-item
          v-for="(item, index) in companyList"
          :key="index"
          :title="item.title"
          :content="item.content"
          :id="item.id"
      />
    </div>
    <div style="display: flex; justify-content: center;padding-bottom: 20px;padding-top: 20px" v-if="total > 0">
      <el-pagination background layout="prev, pager, next,total" :total="total" :page-size="query.pageSize"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <!--    <div style="height: 30px;"></div>-->
  </div>
</template>

<script>
// 导入我们创建的 NewsItem 子组件
import CompanyItem from './CompanyItem.vue';
import {equipmentBusinessList} from "@/http/factory/add-eme";
import RentTabs from "@/components/rentTabs.vue";

export default {
  name: 'App',
  components: {
    RentTabs,
    CompanyItem
  },
  data() {
    return {
      // 从图片中提取的文本和图片路径数据
      companyList: [],
      total: 0,
      query: {
        name: null,
        pageSize: 10,
        pageNum: 1,
      },
    };
  },
  created() {
    this.getCompanyList();
  },
  methods: {
    getCompanyList() {
      equipmentBusinessList(this.query).then((res) => {
        this.total = res.total;
        this.companyList = [];
        for (let item of res.rows) {
          this.companyList.push({
            id: item.id,
            title: item.companyName,
            content: item.companyIntroduce
          });
        }
      });
    },
    handleCurrentChange(val) {
      this.query.pageNum = val;
      this.getCompanyList();
    },
    serach(){
      this.query.pageNum = 1;
      this.getCompanyList();
    },
  }
};
</script>

<style>

.img-top {
  height: 2.1rem;
  background-color: #c4c4c4;
  background-image: url("../../assets/image/banner3.jpg");
  background-size: 100% 100%;
  padding: 0.59rem 0 0 2rem;
  -webkit-box-sizing: border-box;
}

.section-tabs {
  /* padding: 0 2rem; */
  background: #ffffff;
  width: 15.19rem;
  margin: 0 auto;
}
</style>
